/*
 * Copyright (C) 2019-2022 Corvalent Corporation - All Rights Reserved
 * This software is licensed program property and is Proprietary and Confidential.
 * Unauthorized copying of this file via any medium is strictly prohibited unless
 * prior written permission has been obtained by Corvalent Corporation.
 * In addition, the look and feel of this software as well as the user interface
 * design is also Copyright ©.
 * Notice: This software is not open source.
 * This software is subject to the Corvalent Software License Agreement.
 * You should have received a copy of this license with the software.
 * If not, please write to: sales@corvalent.com
 * All information contained herein is, and remains, the property of
 * Corvalent Corporation and its suppliers, if any. This software may also
 * be covered by U.S. and Foreign Patents, patents in progress, and are
 * protected by trade secret or copyright law
 */

import styled from 'styled-components';

export const OverrallStatusLabel = styled.div`
  display: inline-flex;
  padding: 0.2rem;
  border: 0.2em solid #fff;
  border-radius: 0.1875rem;
  margin: 0;
  padding-left: 0.6rem;
  padding-right: 0.6rem;
  min-width: 10rem;
  word-break: normal;
  font-size: 0.75rem;
  text-align: center;
  color: white;
  text-align: left;
  width: 100%;
  background-color: ${props => props.$backgroundColor};

  p {
    margin: 0;
  }

  div:last-child {
    font-weight: 800;
    text-transform: uppercase;
    padding-left: 0.5rem;
  }
`;
